var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
let CycleBarPreviousButton = class CycleBarPreviousButton extends React.PureComponent {
    get prefix() {
        if (runtime.solidBrowserRuntime.browserDevice.isSmartphone)
            return null;
        return React.createElement("span", { style: { fontSize: 15, marginRight: 10 } }, "Vorige Frage");
    }
    render() {
        const { app } = this.props;
        if (!app.answer)
            return null;
        if (app.answer.answerInfo.indexInTray === 0)
            return null;
        return (React.createElement("a", { className: "CycleBarPrevNextButton", href: app.cycle.cycleNavigate.previousHref, onClick: app.cycle.cycleNavigate.handlePreviousClick },
            React.createElement("i", { className: "fas fa-chevron-left", style: { marginRight: 10, marginLeft: 10 } }),
            this.prefix));
    }
};
CycleBarPreviousButton = __decorate([
    observer
], CycleBarPreviousButton);
export { CycleBarPreviousButton };
